import type { IconName } from '@aspendental/shared-components-web';
import type { ComponentType } from 'react';

import AspenOffice from './AspenOffice';
import BrokenTooth from './BrokenTooth';
import CalendarDateTime from './CalendarDateTime';
import CheckUp from './CheckUp';
import Dentures from './Dentures';
import Emergency from './Emergency';
import Implant from './Implant';
import Invisalign from './Invisalign';
import SentimentVeryBad from './SentimentVeryBad';
import Yourself from './Yourself';

type LocalIconName = IconName | 'SentimentVeryBad';

const iconMap: Partial<Record<LocalIconName, ComponentType<any>>> = {
	AspenOffice,
	BrokenTooth,
	CalendarDateTime,
	CheckUp,
	Dentures,
	Emergency,
	Implant,
	Invisalign,
	SentimentVeryBad,
	Yourself,
};

export default iconMap;
